export const convertMinsToHrsMins = (mins: any) => {
  let h: any = Math.floor(mins / 60);
  let m: any = Math.round(mins % 60);
  m = m < 10 ? "0" + m : m;
  return `${h}H ${m !== "00" ? `${m}M` : ""}`;
};
